import { SET_MERGE_INTERSECT_OPERATION } from '../../constants/appTypes';

const initialState: string = 'merge';

interface selectedMergeIntersectOperationAction {
  selectedOperation: string;
  type: string;
}

export function selectedMergeIntersectOperation(state = initialState, action: selectedMergeIntersectOperationAction) {
  switch (action.type) {
    case SET_MERGE_INTERSECT_OPERATION:
      state = action.selectedOperation;
      return state;
    default:
      return state;
  }
}

export default selectedMergeIntersectOperation;
